module.exports = __webpack_public_path__ + "media/store/images/twitter-d62a0547d898968d9337eab556de0a9d.svg";